"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionWrapper = exports.StyledAccordionWrapper = void 0;
const react_1 = __importDefault(require("react"));
const Accordion_1 = __importDefault(require("@material-ui/core/Accordion"));
const withStyles_1 = __importDefault(require("@material-ui/styles/withStyles"));
const theme_1 = __importDefault(require("../../styles/theme"));
/**
 *
 * An accordion is to be built with three different components. The AccordionWrapper should
 * contain both the AccordionSummary (the always visible content) and the AccordionDetails
 * (the content that gets toggled).
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
exports.StyledAccordionWrapper = withStyles_1.default({
    root: {
        boxShadow: 'none',
        margin: `${theme_1.default.spacing.none}`,
        borderTop: `1px ${theme_1.default.colors.borderDefault} solid`,
        borderBottom: `1px ${theme_1.default.colors.borderDefault} solid`,
        borderRadius: '0',
        '&:before': {
            display: 'none',
        },
        '&:not(:last-child)': {
            borderBottom: 'none',
        },
        '&:last-child': {
            borderRadius: '0',
        },
    },
    expanded: {
        margin: `${theme_1.default.spacing.none}`,
    },
})(Accordion_1.default);
const AccordionWrapper = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(Accordion_1.default, Object.assign({}, rest), children));
};
exports.AccordionWrapper = AccordionWrapper;
exports.default = exports.AccordionWrapper;
